<template>
  <b-container>
    <div>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <h1 class="page-title">{{ $t('Dashboard') }}</h1>
      </div>

      <div class="row">

        <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
          <card-component
            :value="card1Value"
            background-color="main-color"
            title="dashboard.card.title.operations"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
          <card-component
            :value="card2Value"
            background-color="main-color"
            title="dashboard.card.title.clients"/>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
          <card-component
            :value="card3Value"
            background-color="main-color"
            title="dashboard.card.title.collaborateurs"/>
        </div>

      </div>

      <dashboard-users-component/>

    </div>

  </b-container>
</template>

<script>

import api from "../../services/api";
import CardComponent from "../../components/b122/CardComponent";
import DashboardUsersComponent from "./components/DashboardUsersComponent";

export default {
  name: "DashboardAdmin",

  components: {
    CardComponent,
    DashboardUsersComponent
  },

  data() {
    return {
      card1Value: null,
      card2Value: null,
      card3Value: null,
      card4Value: null
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    fetchData() {
      this.fetchDashboardData()
    },

    fetchDashboardData() {
      api
        .get(`/dashboard/getDashboardAdminInfos`)
        .then(response => {
          this.card1Value = response.data.card1Value
          this.card2Value = response.data.card2Value
          this.card3Value = response.data.card3Value
          this.card4Value = response.data.card4Value
        })
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dashboard/DashboardAdmin.vue